// utils/unitedKingdomSectionsInfo.js
import React from 'react';
import { Coin, Globe2, Pen, People, ReceiptCutoff, Shield, Tree, Building, ShieldShaded } from 'react-bootstrap-icons';

const JudicialIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF">
    <path d="M160-120v-80h480v80H160Zm226-194L160-540l84-86 228 226-86 86Zm254-254L414-796l86-84 226 226-86 86Zm184 408L302-682l56-56 522 522-56 56Z"/>
  </svg>
);

const ClockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
    <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z"/>
    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0"/>
  </svg>
);

const InfrastructureIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
    <path d="M4 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/>
    <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm11 0H3v14h3v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V15h3z"/>
  </svg>
);

const ScienceIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
    <path d="M9.752 6.193c.599.6 1.73.437 2.528-.362.798-.799.96-1.932.362-2.531-.599-.6-1.73-.438-2.528.361-.798.8-.96 1.933-.362 2.532Z"/>
    <path d="M15.811 3.312c-.363 1.534-1.334 3.626-3.64 6.218l-.24 2.408a2.56 2.56 0 0 1-.732 1.526L8.817 15.85a.51.51 0 0 1-.867-.434l.27-1.899c.04-.28-.013-.593-.131-.956a9.42 9.42 0 0 0-.249-.657l-.082-.202c-.815-.197-1.578-.662-2.191-1.277-.614-.615-1.079-1.379-1.275-2.195l-.203-.083a9.556 9.556 0 0 0-.655-.248c-.363-.119-.675-.172-.955-.132l-1.896.27A.51.51 0 0 1 .15 7.17l2.382-2.386c.41-.41.947-.67 1.524-.734h.006l2.4-.238C9.005 1.55 11.087.582 12.623.208c.89-.217 1.59-.232 2.08-.188.244.023.435.06.57.093.067.017.12.033.16.045.184.06.279.13.351.295l.029.073a3.475 3.475 0 0 1 .157.721c.055.485.051 1.178-.159 2.065Zm-4.828 7.475.04-.04-.107 1.081a1.536 1.536 0 0 1-.44.913l-1.298 1.3.054-.38c.072-.506-.034-.993-.172-1.418a8.548 8.548 0 0 0-.164-.45c.738-.065 1.462-.38 2.087-1.006ZM5.205 5c-.625.626-.94 1.351-1.004 2.09a8.497 8.497 0 0 0-.45-.164c-.424-.138-.91-.244-1.416-.172l-.38.054 1.3-1.3c.245-.246.566-.401.91-.44l1.08-.107-.04.039Zm9.406-3.961c-.38-.034-.967-.027-1.746.163-1.558.38-3.917 1.496-6.937 4.521-.62.62-.799 1.34-.687 2.051.107.676.483 1.362 1.048 1.928.564.565 1.25.941 1.924 1.049.71.112 1.429-.067 2.048-.688 3.079-3.083 4.192-5.444 4.556-6.987.183-.771.18-1.345.138-1.713a2.835 2.835 0 0 0-.045-.283 3.078 3.078 0 0 0-.3-.041Z"/>
    <path d="M7.009 12.139a7.632 7.632 0 0 1-1.804-1.352A7.568 7.568 0 0 1 3.794 8.86c-1.102.992-1.965 5.054-1.839 5.18.125.126 3.936-.896 5.054-1.902Z"/>
  </svg>
);

const JusticeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
    <path d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/>
    <path d="m5.93 6.704-.846 8.451a.768.768 0 0 0 1.523.203l.81-4.865a.59.59 0 0 1 1.165 0l.81 4.865a.768.768 0 0 0 1.523-.203l-.845-8.451A1.5 1.5 0 0 1 10.5 5.5L13 2.284a.796.796 0 0 0-1.239-.998L9.634 3.84a.7.7 0 0 1-.33.235c-.23.074-.665.176-1.304.176-.64 0-1.074-.102-1.305-.176a.7.7 0 0 1-.329-.235L4.239 1.286a.796.796 0 0 0-1.24.998l2.5 3.216c.317.316.475.758.43 1.204Z"/>
  </svg>
);

/**
 * Section information configuration for United Kingdom
 */
const unitedKingdomSectionsInfo = {
  uk: {
    recent: {
      title: 'Recent Updates',
      description: 'Latest government announcements, policy updates, and breaking news from across all UK government departments and agencies.',
      imageSrc: '/ukRecent.png',
      iconComponent: <ClockIcon />,
      learnMoreLink: 'https://www.gov.uk/',
      externalLinks: [
        { label: 'gov.uk', url: 'https://www.gov.uk/' },
        { label: 'Latest News', url: 'https://www.gov.uk/search/news-and-communications' },
        { label: 'Policy Updates', url: 'https://www.gov.uk/government/policies' }
      ]
    },
    legislative: {
      title: 'Legislative Branch',
      description: 'The UK Parliament consists of the House of Commons with 650 elected MPs and the House of Lords with appointed peers. Parliament makes laws, debates national issues, and holds the government to account through questions and select committees.',
      iconComponent: <Pen />,
      learnMoreLink: 'https://www.parliament.uk/',
      externalLinks: [
        { label: 'parliament.uk', url: 'https://www.parliament.uk/' },
        { label: 'Bills & Legislation', url: 'https://bills.parliament.uk/' },
        { label: 'House of Commons', url: 'https://www.parliament.uk/business/commons/' },
        { label: 'House of Lords', url: 'https://www.parliament.uk/business/lords/' }
      ]
    },
    executive: {
      title: "Executive Branch",
      description: "The UK executive is led by the Prime Minister and includes government ministers who head various departments. The Prime Minister is the leader of the political party that commands confidence in the House of Commons and oversees the day-to-day running of government.",
      iconComponent: <People/>,
      learnMoreLink: "https://www.gov.uk/government/how-government-works",
      externalLinks: [
        { label: "Prime Minister's Office", url: "https://www.gov.uk/government/organisations/prime-ministers-office-10-downing-street" },
        { label: "Cabinet Office", url: "https://www.gov.uk/government/organisations/cabinet-office" },
        { label: "Government Departments", url: "https://www.gov.uk/government/organisations" },
        { label: "How Government Works", url: "https://www.gov.uk/government/how-government-works" }
      ]
    },
    judicial: {
      title: "Judicial Branch",
      description: "The UK's highest court is the Supreme Court, established in 2009, which hears appeals from courts across the UK. The judicial system is independent from government and includes the Court of Appeal, High Court, Crown Courts, and Magistrates' Courts.",
      iconComponent: <JudicialIcon/>,
      learnMoreLink: "https://www.supremecourt.uk/",
      externalLinks: [
        { label: "Supreme Court", url: "https://www.supremecourt.uk/" },
        { label: "Courts & Tribunals", url: "https://www.gov.uk/courts-tribunals" },
        { label: "Judiciary", url: "https://www.judiciary.uk/" }
      ]
    },
    defense: {
      title: "Defense",
      iconComponent: <Shield/>
    },
    economy: {
      title: "Economy",
      iconComponent: <Coin/>
    },
    environment: {
      title: "Environment",
      iconComponent: <Tree />
    },
    foreignAffairs: {
      title: "Foreign Affairs",
      iconComponent: <Globe2 />
    },
    health: {
      title: "Health",
      iconComponent: <ShieldShaded />
    },
    infrastructure: {
      title: "Infrastructure",
      iconComponent: <InfrastructureIcon />
    },
    justice: {
      title: "Justice",
      iconComponent: <JusticeIcon />
    },
    science: {
      title: "Science & Technology",
      iconComponent: <ScienceIcon />
    }
  }
};

export default unitedKingdomSectionsInfo;